export var SIGN_IN = 'https://marvelapp.com/signin';
export var UPGRADE = 'https://marvelapp.com/upgrade/';
export var SIGN_UP = 'https://marvelapp.com/signup';
export var SIGN_UP_GOOGLE = 'https://marvelapp.com/auth/drive_auth_start';
export var HOMEPAGE = 'https://marvelapp.com/';
export var HANDOFF = 'https://marvelapp.com/handoff';
export var USER_FLOWS = 'https://userflows.marvelapp.com/';
